// extracted by mini-css-extract-plugin
export default {"body":"body-uODxcVtK","description":"description-kI39cVRM","price":"price-CGd5XZLe"};